import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PurchaseOrderEvent } from "../../types/purchase-order.type";
import { formatDateTimeBkk } from "../../utils/date";
import {
  eventDetailText,
  PO_EMPTY_TEXT,
  PURCHASE_ORDER_EVENT_LABEL,
} from "./data";

interface EventTimelineProps {
  events: PurchaseOrderEvent[];
}

/** ประวัติของ PO ใบหนึ่ง (W6) เรียงตามลำดับที่ API ส่งมา */
export default function EventTimeline({ events }: EventTimelineProps) {
  if (events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        ยังไม่มีประวัติ
      </Typography>
    );
  }

  return (
    <Stack gap={1.5}>
      {events.map((event) => {
        const detail = eventDetailText(event);

        return (
          <Stack key={event.uuid} direction="row" gap={1.5}>
            <Box
              sx={{
                mt: 0.75,
                width: 10,
                height: 10,
                flexShrink: 0,
                borderRadius: "50%",
                bgcolor: "primary.main",
              }}
            />
            <Stack sx={{ minWidth: 0 }}>
              <Typography variant="body2" fontWeight={600}>
                {PURCHASE_ORDER_EVENT_LABEL[event.type]}
              </Typography>
              {detail && (
                <Typography variant="body2" color="text.secondary">
                  {detail}
                </Typography>
              )}
              <Typography variant="caption" color="text.secondary">
                {formatDateTimeBkk(event.created_at) || PO_EMPTY_TEXT} · โดย{" "}
                {event.actor_name || PO_EMPTY_TEXT}
              </Typography>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
}
